import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import type { IActions } from '../interface/IAction';
import { actions as actionCreators } from '../store/actions';

export const useReduxActions = (): IActions => {
	const dispatch = useDispatch();
	return useMemo(() => bindActionCreators(actionCreators, dispatch) as unknown as IActions, [dispatch]);
};
